import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { PorterGuideFAQ } from '../../components/FAQs';

export default function PorterGuideFAQModal() {

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <>
      <span onClick={openModal} className="faq">Frequently Asked Questions (FAQs)</span>
      <Modal isOpen={isOpen} toggle={toggleModal} className="porter-faq">
        <ModalHeader toggle={toggleModal}>
            Porter-guide Frequently Asked Questions (FAQs)
        </ModalHeader>
        <ModalBody>
          <PorterGuideFAQ />
        </ModalBody>
      </Modal>
    </>
  );
};
